import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../common/services/common.service';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { AssetLibraryConstants } from '../../../../core/routing/services/asset-library/constants/asset-library.constant';

@Component({
  selector: 'iposcen-content-live-preview',
  templateUrl: './content-live-preview.component.html',
  styleUrls: ['./content-live-preview.component.scss']
})
export class ContentLivePreviewComponent implements OnInit, OnDestroy {
  @Input() imageData;
  @Input() sidenav;
  @Input() defaultLogo = [];
  @Input() tabindex;
  @Input() presentpage;
  @Input() customTilepresentpage;
  @Input() customTiletabindex;
  @Input() segmentspresentPage;
  @Input() pricePresentPage;
  @Input() herotilePresentPage;
  @Input() herotiletabIndex;
  @Input() tileSRT;
  @Input() enableAIIPOSPreview;
  @Input() isSegmentFrameVisible: boolean = true;
  @Input() secondPreview;
  @Input() AIPreviewData;
  @Input() logoPresentPage;
  @Input() hideOptions: boolean = false;
  imageURL: string;
  segmentBgColor: string;
  segmentFontColor: string;
  segmentBgColorWithOpacity: string;
  bannerPresentPage: string;
  /** Language Fix - start */
  languageCode: string;
  /** Language Fix - end */
  iposBrandColor: string;
  segments: string = GlobalConstants.SEGMENTS;
  heroTile: string = GlobalConstants.HERO_TILE;
  globalconst = GlobalConstants;
  private ngUnsubscribe = new Subject<boolean>();
  defaultLogoImage: any;
  highlightLogo: any;
  heroTileSelectedImage: string = '';
  heroTileSelectedCTAvValue = AssetLibraryConstants.CALL_TO_ACTION_CUSTOM_PLACEHOLDER;
  @Input() sendctavalue;
  partnerContentSelectedThumbnailImg: string = '';
  heroTilePreview = false;
  bgColor: string;
  popUpPreviewObj: object={};
  private ackModalOption: NgbModalOptions = {};
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  changePlacement: boolean = false;
  isOEM:boolean = false;
  previewTabs = ["Wildcat","Panther","Lunar","CoreUltra", "CoreProcessor", "Evo"];
  previousSelectedTab : string = '';
  activePreviewTab : string = 'Wildcat';
  constructor(private cmnSer: CommonService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.ackModalOption.backdrop = 'static';
    this.ackModalOption.keyboard = false;
    this.defaultLogoImage = 'assets/images/preview_footer_logo.svg';
    /** Language Fix - start */
    this.languageCode = (localStorage.getItem('preferredLanguage')) ? localStorage.getItem('preferredLanguage') : '';
    /** Language Fix - end */
    this.imageURL = this.imageData || '';
    if (this.sidenav === GlobalConstants.SEGMENTS) {
      this.segmentBgColor = GlobalConstants.STORELOGO_BGCOLOR;
      this.segmentBgColorWithOpacity = GlobalConstants.LIVE_PREVIEW_DEFAULT_BGCOLOR;
    }
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    this.cmnSer.emitDataToLivePreviewObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resp => {
        setTimeout(() => {
          if (resp.page === GlobalConstants.BANNER) {
            if(resp.dataSet?.image){
              this.imageURL = resp.dataSet.image.url;
              this.cmnSer.uploadedImageURL = this.imageURL;
            }
            this.bgColor = resp.dataSet?.bgColor ? resp.dataSet?.bgColor  : '';
          } else if (resp.page === GlobalConstants.SEGMENTS) {
            if (resp.dataSet.isIposBrandColor) {
              this.segmentBgColor = resp.dataSet.bgcolor;
              this.segmentFontColor = resp.dataSet.hcolor;
              this.iposBrandColor = resp.dataSet.iposBrandColor;
              this.segmentBgColorWithOpacity = this.iposBrandColor.concat(GlobalConstants.OPACITY_VALUE);
            } else {
              this.segmentBgColor = resp.dataSet.bgcolor;
              this.segmentFontColor = resp.dataSet.hcolor;
              this.segmentBgColorWithOpacity = resp.dataSet.isApplyToIpos ?
                this.segmentBgColor.concat(GlobalConstants.OPACITY_VALUE) : GlobalConstants.LIVE_PREVIEW_DEFAULT_BGCOLOR;
            }
          } else if (resp.page === GlobalConstants.HERO_TILE || resp.page === GlobalConstants.CUSTOM_TILE) {
            this.bgColor = resp.dataSet?.bgColor;
            if(resp?.dataSet?.image){

              this.heroTileSelectedImage = resp.dataSet.image.url;
            }
            if(resp.dataSet?.button?.value){

              this.heroTileSelectedCTAvValue = resp.dataSet.button.value ? resp.dataSet.button.value : AssetLibraryConstants.CALL_TO_ACTION_CUSTOM_PLACEHOLDER;
            }
          }  else if (resp.page === GlobalConstants.PARTNER_CONTENT_CREATION) {
            if(resp.dataSet?.image){
              this.imageURL = resp.dataSet.image.url;
              this.partnerContentSelectedThumbnailImg = resp.dataSet.image.url;
            }
            this.bgColor = resp.dataSet?.bgColor ? resp.dataSet?.bgColor  : '';
          }
        }, 0);
      });

      this.cmnSer.getPresentPageValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
       this.bannerPresentPage = data;
      });
      this.cmnSer.emitLivePreviewDataToProfileObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if(data[0] && data[0]?.imageData){
          this.defaultLogoImage =  data[0]?.imageData;
        }
      });
    //To show default log on logo preview
    if (this.sidenav === GlobalConstants.LOGO_CONTENT_GROUP) {
      if (this.defaultLogo.length) {
        this.defaultLogoImage = this.defaultLogo[0].imageData;
        this.highlightLogo = 'price_highlighted';
      } else {
        this.defaultLogoImage = 'assets/images/image_icon.svg';
        this.highlightLogo = 'price_highlighted';
      }
      if(this.enableAIIPOSPreview){
        this.defaultLogoImage = this.AIPreviewData;
      }
    }

    if(this.sidenav === 'hero_tile' || this.sidenav === this.heroTile || this.sidenav === this.globalconst.CUSTOM_TILE || this.sidenav === this.globalconst.CUSTOM_AND_HERO) {
      this.heroTilePreview = true;
    }

    this.cmnSer.emitLivePreviewDataToLivePreviewComponentObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        this.heroTileSelectedImage = res;
      })

      this.cmnSer.emitLivePreviewDataToLivePreviewComponentObserCTA
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if(res) {
          this.heroTileSelectedCTAvValue = res;
        } else {
          this.heroTileSelectedCTAvValue = AssetLibraryConstants.CALL_TO_ACTION_CUSTOM_PLACEHOLDER;
        }
      })
      if(!this.enableAIIPOSPreview && this.sidenav ===  GlobalConstants.PARTNER_CONTENT_GROUP){
        this.isOEM = true;
      }
    }
    decideBgColor(){
      if(this.sidenav === GlobalConstants.PARTNER_CONTENT_GROUP && this.imageURL !== ''){
        return this.bgColor;
      }else if(this.sidenav === GlobalConstants.CUSTOM_TILE && this.heroTileSelectedImage !== '' ){
        return this.bgColor;
      } 
      else if(this.sidenav === 'banner' && this.imageURL !== ''){
        return this.bgColor;
      }else if(this.sidenav === 'hero_tile' && this.heroTileSelectedImage !== ''){
        return this.bgColor;
      }
    }
    checkImageData(){
      if(this.sidenav === 'banner'){
        return this.heroTileSelectedImage === '' && this.imageURL === '';
      }else if(this.sidenav === 'PartnerContentGroup'){
        return this.heroTileSelectedImage === '' && this.imageURL === '';
      }else{
        return this.heroTileSelectedImage === '' || this.imageURL === '' && this.sidenav === this.segments || this.sidenav === 'LogoContentGroup'
      }
    }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  openPreviewPopup(modal) {
    this.isSegmentFrameVisible = false; 
    this.previousSelectedTab = this.activePreviewTab;
    this.selectPreviewTab('Evo');
    this.popUpPreviewObj={
      popUp:true,
      segmentProperty:{segmentBgColor:this.segmentBgColor},
      bannerProperty:{bannerBgColor:this.bgColor,imageURL:this.imageURL},
      heroTileProperty:{heroTileSelectedImage: this.heroTileSelectedImage, bgColor: this.bgColor}
    } 
    this.modalService.open(modal, this.ackModalOption);
  }

  closeModal() {
    if(this.modalService.hasOpenModals()) {
      this.selectPreviewTab(this.previousSelectedTab);
      this.isSegmentFrameVisible = true;
      this.modalService.dismissAll();
      this.previousSelectedTab = '';
    }
  }

  selectPreviewTab(selectedTab: string) {
    this.activePreviewTab = selectedTab;
  }
}
